export const RE_ESTABLISHMENT_FEE_NAME = "Re-Establishment Fee"

const OUTSTANDING_DUES_ORDER_STATUSES = new Set(["open", "pending"])

const lineItemsIncludeReestablishmentFee = lineItems =>
  lineItems?.some(item => item?.name === RE_ESTABLISHMENT_FEE_NAME)

export const orderHasOutstandingReestablishmentFee = order => {
  if (!order || order.orderType !== "dues") return false
  if (!OUTSTANDING_DUES_ORDER_STATUSES.has(order.status)) return false
  if (!order.balance || order.balance <= 0) return false

  return lineItemsIncludeReestablishmentFee(order.lineItems)
}

export const orderHasPayableReestablishmentFee = order =>
  orderHasOutstandingReestablishmentFee(order) && order.payable === true

export const duesCycleHasReestablishmentFee = duesCycle =>
  lineItemsIncludeReestablishmentFee(duesCycle?.order?.lineItems)

export const duesCycleHasPayableReestablishmentFee = duesCycle => {
  const order = duesCycle?.order
  if (!order?.payable) return false

  return lineItemsIncludeReestablishmentFee(order.lineItems)
}

export const hasOutstandingReestablishmentFee = ({ duesCycle, orders }) =>
  duesCycleHasReestablishmentFee(duesCycle) ||
  orders?.some(orderHasOutstandingReestablishmentFee)

export const hasPayableReestablishmentFee = ({ duesCycle, orders }) =>
  duesCycleHasPayableReestablishmentFee(duesCycle) ||
  orders?.some(orderHasPayableReestablishmentFee)
